'use client';

import { createContext } from 'react';
import { ProcessingCostInfo } from '@/types/ApiResponse';
import { Bid } from '@/types/bid';
import { DeliveryMethod, ReceiptChoice } from '@/types/ListEntry';
import { EntryMetadata } from '@/types/Metadata/Metadata';

interface BiddingContextValue {
  entryId: number;
  slug: string;
  deliveryMethods: DeliveryMethod[];
  receiptTypes: ReceiptChoice[];
  vatPerc: number;
  minimumRaise: number;
  processingCostInfo: ProcessingCostInfo | null;
  title: string;
  companyName: string;
  categoryName: string;
  categoryId: number;
  parentCategoryName: string | null;
  parentCategoryId: number | null;
  startPrice: number;
  auctionStart: Date;
  auctionEnd: Date;
  postTradingStartedAt: Date | null;
  bids: Bid[] | null;
  debt: number | null | undefined;
  deliveryExpensesAvailable: boolean;
  location: string;
  metadata: EntryMetadata | null;
  isOwnPayment: boolean;
}

export const BiddingContext = createContext<BiddingContextValue>({
  entryId: 0,
  slug: '',
  deliveryMethods: [],
  receiptTypes: [],
  vatPerc: 0,
  minimumRaise: 0,
  processingCostInfo: null,
  title: '',
  companyName: '',
  categoryName: '',
  categoryId: 0,
  parentCategoryName: '',
  parentCategoryId: null,
  startPrice: 0,
  auctionStart: new Date(),
  auctionEnd: new Date(),
  bids: null,
  debt: undefined,
  deliveryExpensesAvailable: false,
  location: '',
  postTradingStartedAt: null,
  metadata: null,
  isOwnPayment: false,
});

export function BiddingContextProvider({ value, children }: { value: BiddingContextValue; children: React.ReactNode }) {
  return <BiddingContext.Provider value={value}>{children}</BiddingContext.Provider>;
}
